<template>
  <div class="page">
    <div class="page-container">
      <div class="page-title">项目阶段性计划</div>
      <div class="panel-body">
        <div class="w800">
          <a-steps progress-dot class="v-mt-md v-mb-lg" size="small" :current="currentStep">
            <a-step title="填报项目阶段性计划">
              <div slot="description" style="white-space: nowrap; font-size: 12px" v-if="data.state > 0">
                <div>{{ data.submitTime ? data.submitTime.substring(0, 16) : '' }}</div>
              </div>
            </a-step>
            <a-step title="项目主管审核" />
            <a-step title="完成" />
          </a-steps>
        </div>
        <a-alert class="v-mb-sm no-border" type="error" v-if="data.taskCheckResult == -1">
          <div slot="message">
            <div class="font-md text-darkblue flex items-center"><a-icon type="alert" class="v-mr-xs" />提交的项目阶段性计划已被驳回</div>
            <div class="flex v-mt-xs">
              <span class="text-right text-grey">审核意见：</span>
              <span class="col text-red" v-html="$utils.convertToHtml(data.taskCheckOpinion)"></span>
            </div>
          </div>
        </a-alert>
        <div class="panel-info-section relative-position">
          <div class="panel-info-section-title">
            <a-icon type="caret-right" class="text-primary" />
            <span class="text-bold">阶段性计划基本信息</span>
          </div>
          <table class="table table-plain">
            <tbody>
              <tr>
                <th width="160">阶段性计划名称</th>
                <td width="38%">{{ data.planName }}</td>
                <th width="160">提交日期</th>
                <td>{{ data.submitTime ? data.submitTime.substring(0, 16) : '' }}</td>
              </tr>
              <tr>
                <th>业务范围</th>
                <td>
                  <a-tag color="purple">
                    <template v-if="data.projectType == 11">合作项目—公募合作</template>
                    <template v-else-if="data.projectType == 12">合作项目—公募合作</template>
                    <template v-else-if="data.projectType == 21">螺蛳壳改造</template>
                    <template v-else-if="data.projectType == 22">精灵书屋</template>
                    <template v-else-if="data.projectType == 23">公益人才</template>
                    <template v-else-if="data.projectType == 24">爱心 100</template>
                    <template v-else-if="data.projectType == 25">其他项目</template>
                  </a-tag>
                </td>
                <th>实施时间</th>
                <td>
                  <span>
                    {{ data.startDate ? data.startDate.substring(0, 10) : '' }}
                    <template v-if="data.endDate">~ {{ data.endDate.substring(0, 10) }}</template>
                  </span>
                </td>
              </tr>
              <tr valign="top">
                <th>实施地点</th>
                <td colspan="3">
                  <span>{{ $utils.flatAddress(data.addresses) }}</span>
                </td>
              </tr>
              <tr>
                <th valign="top">备注</th>
                <td colspan="3">
                  <span>{{ data.remark }}</span>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <div class="panel-info-section relative-position">
          <div class="panel-info-section-title">
            <div class="flex items-center">
              <a-icon type="caret-right" class="text-primary" />
              <span class="text-bold">阶段性计划任务明细</span>
            </div>
          </div>
          <a-table key="table-edit" class="list-table" size="small" rowKey="uid" :loading="loading" :expanded-row-keys.sync="expandedTableKeys" :pagination="false" :data-source="tasks" :scroll="{ x: '100%' }" :expand-icon-column-index="1">
            <a-table-column title="序号" data-index="index" :width="60" align="left">
              <template slot-scope="text, record">
                {{ record.no }}
              </template>
            </a-table-column>
            <a-table-column title="任务名称" data-index="taskName" :ellipsis="true" :width="280" align="left">
              <template slot-scope="text, record">
                {{ record.taskName }}
              </template>
            </a-table-column>
            <a-table-column title="任务类型" data-index="taskType" :width="80" align="center">
              <template slot-scope="text, record">
                <template v-if="!(record.children && record.children.length)">{{ record.taskType }}</template>
              </template>
            </a-table-column>
            <a-table-column title="任务周期" data-index="range" :width="190" align="center">
              <template slot-scope="text, record">
                <template v-if="!(record.children && record.children.length)">{{ record.startDate ? record.startDate + '~' + record.endDate : '-' }}</template>
              </template>
            </a-table-column>
            <a-table-column title="历时（天）" data-index="period" :width="90" align="center">
              <template slot-scope="text, record">
                <span v-if="record.startDate && record.endDate">{{ $utils.diffDays(record.startDate, record.endDate) }}d</span>
              </template>
            </a-table-column>
            <a-table-column title="责任人" data-index="ownerType" :width="100">
              <template slot-scope="text, record">
                <span>{{ record.ownerType ? (record.ownerType == 1 ? '项目官员' : '施工方') : '-' }}</span>
              </template>
            </a-table-column>
            <a-table-column title="备注" data-index="remark" :width="200" :ellipsis="true">
              <template slot-scope="text, record">
                <template v-if="!(record.children && record.children.length)">{{ record.remark }}</template>
              </template>
            </a-table-column>
          </a-table>
        </div>
        <div class="panel-info-section relative-position">
          <div class="panel-info-section-title">
            <div class="flex items-center">
              <a-icon type="caret-right" class="text-primary" />
              <span class="text-bold">关联项目</span>
            </div>
          </div>
          <a-table class="list-table" size="small" :bordered="false" :pagination="false" :loading="projectLoading" :data-source="projects" :scroll="{ x: '100%' }" rowKey="id">
            <a-table-column title="#" data-index="index" :width="45" align="center" fixed="left">
              <template slot-scope="text, record, index">{{ index + 1 }}</template>
            </a-table-column>
            <a-table-column title="项目状态" data-index="state" align="left" :width="120" fixed="left">
              <template slot-scope="text, record">
                <span class="text-grey" v-if="text === -1">已终止</span>
                <span class="text-red" v-else-if="text === 0">
                  <div class="line-1" v-if="record.reviewResult === 0">项目申请已驳回</div>
                  <div class="line-1" v-else>项目申请待提交</div>
                </span>
                <span class="text-red" v-else-if="text === 1">项目申请待审核</span>
                <span class="text-red" v-else-if="text === 2">筹款申请待提交</span>
                <span class="text-red" v-else-if="text === 3">筹款申请待审核</span>
                <span class="text-red" v-else-if="text === 7">执行中</span>
                <span class="text-red" v-else-if="text === 8">结项中</span>
                <span class="text-red" v-else-if="text === 9">已结项</span>
              </template>
            </a-table-column>
            <a-table-column title="项目名称" data-index="name" :width="260" :ellipsis="true" align="left" fixed="left">
              <template slot-scope="text, record">
                <router-link class="text-indigo hover-line" :title="text" :to="{ path: 'view', query: { id: record.id } }">{{ text || record.topic }}</router-link>
              </template>
            </a-table-column>
            <a-table-column title="项目编号" data-index="code" :width="115" :ellipsis="true" align="left" fixed="left" />
            <template v-if="data.projectType == 11 || data.projectType == 12">
              <a-table-column title="申请人" data-index="users[0].realName" :width="200" :ellipsis="true" align="left" />
            </template>
            <template v-else-if="data.projectType == 22">
              <a-table-column title="山区学校" data-index="studyInfo.schoolName" :width="150" :ellipsis="true" align="left" />
              <a-table-column title="合作伙伴单位" data-index="studyInfo.cooperatorName" :width="180" :ellipsis="true" align="left" />
            </template>
            <a-table-column title="项目类型" data-index="otherInfo.type" align="left" :width="80" v-else-if="data.projectType == 25">
              <template slot-scope="text">
                <span v-if="text === 1">突发事件</span>
                <span v-else-if="text === 2">重大活动</span>
              </template>
            </a-table-column>
            <a-table-column title="项目周期" data-index="range" :width="180" align="left">
              <template slot-scope="text, record">
                <span>
                  {{ record.startDate ? record.startDate.substring(0, 10) : '' }}
                  <template v-if="record.endDate">~ {{ record.endDate.substring(0, 10) }}</template>
                </span>
              </template>
            </a-table-column>
            <a-table-column title="已完成任务数" data-index="taskDone" :width="102" :ellipsis="true" align="right" />
            <a-table-column title="未完成任务数" data-index="taskTodo" :width="102" :ellipsis="true" align="right" />
            <a-table-column title="预算金额" data-index="raisedAmount" :width="119" align="right">
              <template slot-scope="text, record">
                <span>{{ $utils.thousands(record.raisedAmount) }}</span>
              </template>
            </a-table-column>
            <a-table-column title="请款金额" data-index="appliedAmount" :width="119" align="right">
              <template slot-scope="text, record">
                <span>{{ $utils.thousands(record.appliedAmount) }}</span>
              </template>
            </a-table-column>
            <a-table-column title="实际支出" data-index="expensedAmount" :width="119" align="right">
              <template slot-scope="text, record">
                <span>{{ $utils.thousands(record.expensedAmount) }}</span>
              </template>
            </a-table-column>
            <a-table-column title="请款余额" data-index="remainApplyAmount" :width="119" align="right">
              <template slot-scope="text, record">
                <span>{{ $utils.thousands(record.remainApplyAmount) }}</span>
              </template>
            </a-table-column>
            <a-table-column title="差额" data-index="remainAmount" :width="119" align="right">
              <template slot-scope="text, record">
                <span v-if="record.budgetAmount">{{ $utils.thousands(record.budgetAmount - record.expensedAmount) }}</span>
                <span v-else>-</span>
              </template>
            </a-table-column>
            <template v-if="data.projectType == 11 || data.projectType == 12">
              <a-table-column title="管理费" data-index="manageAmount" :width="110" align="right">
                <template slot-scope="text, record">
                  <span>{{ $utils.thousands(record.manageAmount) }}</span>
                </template>
              </a-table-column>
            </template>
            <template v-if="data.projectType == 21">
              <a-table-column title="申请人(成年人)姓名" data-index="lskInfo.applicantName" :width="140" :ellipsis="true" align="left" />
              <a-table-column title="申请人手机" data-index="lskInfo.applicantPhone" :width="100" :ellipsis="true" align="left" />
              <a-table-column title="房屋地址" data-index="lskInfo.houseAddr" :width="250" :ellipsis="true" align="left" />
            </template>
            <template v-else-if="data.projectType == 22">
              <a-table-column title="合作伙伴联系人" data-index="studyInfo.cooperatorContact" :width="120" :ellipsis="true" align="left" />
              <a-table-column title="合作伙伴联系人手机" data-index="studyInfo.cooperatorPhone" :width="150" :ellipsis="true" align="left" />
              <a-table-column title="书籍接收人" data-index="studyInfo.bookReceiverName" :width="100" :ellipsis="true" align="left" />
              <a-table-column title="书籍接收人手机" data-index="studyInfo.bookReceiverPhone" :width="120" :ellipsis="true" align="left" />
            </template>
            <template v-else-if="data.projectType == 23">
              <a-table-column title="培训班类型" data-index="talentInfo.classType" :ellipsis="true" align="left" />
              <a-table-column title="课时数量" data-index="talentInfo.classHour" :width="80" align="right" />
              <a-table-column title="主讲老师" data-index="talentInfo.teacher" :width="90" align="left" />
              <a-table-column title="主讲老师手机" data-index="talentInfo.teacherPhone" :width="105" :ellipsis="true" align="left" />
              <a-table-column title="授课方式" data-index="talentInfo.teachingMethod" :width="120" :ellipsis="true" align="left" />
            </template>
            <template v-else-if="data.projectType == 24">
              <a-table-column title="被推荐人" data-index="loveInfo.referralName" :width="100" :ellipsis="true" align="left" />
              <a-table-column title="被推荐人电话" data-index="loveInfo.referralPhone" :width="120" :ellipsis="true" align="left" />
              <a-table-column title="被推荐家庭地址" data-index="loveInfo.referralAddr" :width="210" :ellipsis="true" align="left" />
              <a-table-column title="推荐人" data-index="loveInfo.refferrerName" :width="100" :ellipsis="true" align="left" />
              <a-table-column title="推荐人手机" data-index="loveInfo.refferrerPhone" :width="100" :ellipsis="true" align="left" />
            </template>
          </a-table>
        </div>
        <div class="text-center v-mt-lg">
          <a-space>
            <template v-if="isProcessable(data.checkState)">
              <a-button icon="rollback" type="indigo" :loading="saving" @click="handleReviewBackConfirm">驳回</a-button>
              <!-- <a-button icon="arrow-right" type="primary" :loading="saving" v-if="data.checkState === 1" @click="handleConfirmReview">审核通过，提交主管审核</a-button> -->
              <a-button icon="arrow-right" type="primary" :loading="saving" v-if="data.checkState === 2" @click="handleConfirmReview">审核通过</a-button>
            </template>
            <a-button icon="left" key="backward" @click="$router.go(-1)">返回</a-button>
          </a-space>
        </div>
      </div>
    </div>
    <a-modal centered title="驳回项目计划" :visible="rejectModal" @cancel="cancelRejectModal" width="550px" :body-style="{ padding: '12px' }">
      <template slot="footer">
        <a-space>
          <a-button @click="cancelRejectModal">取消</a-button>
          <a-button type="indigo" :loading="saving" @click="handleReview(false, 1)">确认驳回，退回至申请人</a-button>
          <!-- <a-button type="indigo" :loading="saving" @click="handleReview(false, 1)" v-if="data.checkState === 2">确认驳回，退回至官员</a-button> -->
        </a-space>
      </template>
      <a-textarea v-model="rejectReason" :rows="6" placeholder="输入驳回原因" ref="rejectReason" />
    </a-modal>
  </div>
</template>

<script>
import { getStagePlan, reviewStagePlan, getStagePlanProjects } from '@/api/project/stageplan'
import { convertTasksToTableData } from '@/utils/data'
export default {
  name: 'ProjectStagePlanDetail',
  data() {
    return {
      stagePlanId: null,
      data: {},
      loading: false,
      expandedTableKeys: [],
      tasks: [],
      saving: false,
      currentStep: 0,
      rejectModal: false,
      rejectReason: '',
      projects: [],
      projectLoading: false,
    }
  },
  computed: {
    hasChildren() {
      return this.budgetsTableData.some(item => item.children && item.children.length)
    },
    hasTaskChildren() {
      return this.tasksTableData.some(item => item.children && item.children.length)
    },
  },
  watch: {
    $route() {
      this.init()
    },
  },
  methods: {
    init() {
      let { id } = this.$route.query
      if (id) {
        this.stagePlanId = +id
        this.load()
        this.loadProjects()
      }
    },
    load() {
      this.loading = true
      getStagePlan(this.stagePlanId).then(({ data }) => {
        this.loading = false
        if (data.success) {
          let { checkState, tasks = [] } = data.result
          let taskRecords = convertTasksToTableData(tasks)
          this.tasks = taskRecords
          this.expandedTableKeys = taskRecords.filter(d => d.children && d.children.length).map(d => d.uid)
          this.data = data.result
          if (checkState == 0) {
            this.currentStep = 0
          } else if (checkState == 9) {
            this.currentStep = 2
          } else {
            this.currentStep = checkState - 1
          }
        }
      })
    },
    loadProjects() {
      this.projectLoading = true
      getStagePlanProjects(this.stagePlanId).then(({ data }) => {
        if (data.success) {
          this.projects = data.result
        }
        this.projectLoading = false
      })
    },
    cancelRejectModal() {
      this.rejectModal = false
    },
    handleReviewBackConfirm() {
      this.rejectReason = ''
      this.rejectModal = true
    },
    handleConfirmReview() {
      this.$confirm({
        title: '确认审核通过？',
        centered: true,
        onOk: () => {
          this.handleReview(true)
        },
      })
    },
    handleReview(approved, backsteps = 0) {
      let { stagePlanId, rejectReason } = this
      this.$message.destroy()
      if (!approved && rejectReason.trim() === '') {
        this.$message.warn('请输入驳回原因')
        this.$refs.rejectReason.focus()
        return
      }
      let params = {
        stagePlanId,
        result: approved ? 1 : 0,
        backsteps,
        opinion: rejectReason.trim(),
      }
      this.saving = true
      reviewStagePlan(params)
        .then(({ data }) => {
          this.saving = false
          if (data.success) {
            this.$message.success('操作成功')
            this.cancelRejectModal()
            this.$router.go(-1)
          } else {
            this.$message.warn(data.msg)
          }
        })
        .catch(() => {
          this.saving = false
          this.$message.warn('操作失败')
        })
    },
  },
  created() {
    this.init()
  },
}
</script>
